module.exports = __webpack_public_path__ + "img/gs2.66c67f96.png";